import React, { useContext, useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { getLabel } from '../../../Base/Services/Language/LanguageService'

import { encuestasLang } from './EncuestasLang'
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { setTitlePage } from '../../../Base/Services/Config/ConfigService'

import { getEncuestas, setQRStatus } from '../../../API/Gerencia/Encuestas/EncuestasRequests'

import PreguntasEncuestaList from './Preguntas/PreguntasEncuestaList'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { QRCodeSVG } from 'qrcode.react'


const EncuestasScreen = () => {

    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [encuestaShow, setEncuestaShow] = useState(null);
    const [linkEncuestaQR, setLinkEncuestaQR] = useState(null);
    const [row, setRow] = useState({})

    const getInfo = async () => {
        setLoading(true);
        const t = await getEncuestas();
        setData(t);
        setLoading(false);
    }

    const GenerarCodigoLink = (longitud) => {

        const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        let resultado = "";
        for (let i = 0; i < longitud; i++) {
            resultado += letras?.charAt(Math.floor(Math.random() * letras?.length));
        }
        return resultado;

    }

    const columns = [
        {
            header: 'NoEnucuesta',
            handerEn: '',
            field: 'IdEncuesta',
            className: '',
        },
        {
            header: 'Titulo',
            handerEn: '',
            field: 'Titulo',
            className: '',
        },
        {
            header: 'Respuestas',
            handerEn: '',
            field: 'NumRespuestas',
            className: '',
            Format: 'Currency'
        },

        {
            header: '',
            handerEn: '',
            field: 'IdEncuesta',
            className: '',
            Format: 'Botones',
            Botones: [
                {
                    icon: 'pi pi-eye',
                    className: 'p-button-rounded p-button-success p-button-text',
                    tooltip: 'Ver',
                    onClick: (e) => {
                        setEncuestaShow(e)

                    }
                },
                {
                    icon: 'pi pi-pencil',
                    className: 'p-button-rounded p-button-warning p-button-text',
                    tooltip: 'Editar',
                    onClick: (e) => {
                        console.log(e)
                    }
                },
                {
                    icon: 'pi pi-trash',
                    className: 'p-button-rounded p-button-danger p-button-text',
                    tooltip: 'Eliminar',
                    onClick: (e) => {
                        console.log(e)
                    }
                },
                {
                    icon: 'pi pi-qrcode',
                    tooltip: 'QR',
                    onClick: (rowData) => {
                        let codigoLink = GenerarCodigoLink(6)
                        rowData.CodigoLink = codigoLink
                        let link = 'https://were.ppf.com.hn/web/encuesta/QR/' + rowData.IdEncuesta + '/' + codigoLink;
                        // let link = 'http://localhost:4445/web/encuesta/QR/' + rowData.IdEncuesta + '/' + codigoLink;
                        rowData.Link = link
                        changeQRStatus(rowData, true);
                        setRow(rowData)
                        setLinkEncuestaQR(link);
                    }
                },
            ]
        },
        {
            field: 'LinkQRActivo',
            header: 'LinkQRActivo',
            headerEn: '',
            className: 'small',
            Format: 'Checkbox',
            onChange: (rowData, data) => {
                console.log(data);
                changeQRStatus(data?.data);

            }
        },


    ]
    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
    }

    const changeQRStatus = async (rowData, habilitar = false) => {
        setLoading(true);
        const result = await setQRStatus({ ...rowData, LinkQRActivo: !rowData.LinkQRActivo || habilitar ? 1 : 0 });
        setLinkEncuestaQR(rowData.Link);
        getInfo();
        setLoading(false);
    }

    const ActualizarCodigoLink = () => {
        let codigoLink = GenerarCodigoLink(6)
        row.CodigoLink = codigoLink
        let link = 'https://were.ppf.com.hn/web/encuesta/QR/' + row.IdEncuesta + '/' + codigoLink;
        // let link = 'http://localhost:4445/web/encuesta/QR/' + row.IdEncuesta + '/' + codigoLink;
        row.Link = link
        setRow(row)
        if (row) {
            changeQRStatus(row, true);
        }
    }

    useEffect(() => {
        setTitlePage(getLabel(encuestasLang, "titulo", config.language));
        getInfo();
    }, [])

    useEffect(() => {
        if (linkEncuestaQR) {
            const intervalId = setInterval(ActualizarCodigoLink, 300000);
            return () => clearInterval(intervalId);
        }
    }, [linkEncuestaQR])





    return (
        <div>
            <Card
                titulo={<div className='botones'>
                    <h3>{getLabel(encuestasLang, "titulo", config.language)}</h3>
                    <Button icon="pi pi-plus" className="p-button-success" onClick={() => setEncuestaShow({})} />
                    <Button icon="pi pi-refresh" severity="secondary" onClick={() => getInfo()} />
                </div>}
                contenido={<div className='pt-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />

            <PreguntasEncuestaList encuestaShow={encuestaShow} setEncuestaShow={setEncuestaShow} />

            <Dialog header={<h1>Encuesta Clima Laboral</h1>} visible={linkEncuestaQR}  maximized  onHide={() => setLinkEncuestaQR(null)}>

                <div className='d-flex flex-column' >
                    <div className='PasosEncuentas'>
                        <div>Pasos:</div>
                        <span>1- <label>Conectarse al wifi SCPPF (No necesita contraseña)</label></span><br />
                        <span>2- <label>Escanear el codigo QR que se muestra en la pantalla</label></span><br />
                        <span>3- <label>Ingresar a la encuesta y seleccionar su sección </label></span><br />
                        <span>4- <label>Contestar las preguntas de la encuesta </label></span><br />
                        <span>5- <label>Guardar la encuesta </label></span><br />
                    </div>
                    <div className='d-flex justify-content-center gap' style={{ height: 500, alignItems: 'center', flexDirection: 'column' }}>
                        <QRCodeSVG
                            value={linkEncuestaQR}
                            size={500}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"H"}
                            renderAs={"canvas"}
                            imageSettings={{
                                src: "https://were.ppf.com.hn/web/Logo_PPF.png",
                                x: null,
                                y: null,
                                height: 100,
                                width: 100,
                                excavate: true
                            }}
                            imageRendering={"pixelated"}
                        />
                        <a href={linkEncuestaQR} target="_blank" rel="noreferrer"><h2 className='mt-5'>{linkEncuestaQR}</h2></a>

                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default EncuestasScreen